<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import CImage from '../../../editor/nodes/CImage.vue'

export default CImage.extend({
  name: 'CImageV3',
  mixins: [FirebaseNodeV3],
  methods: {
    updateProp: function (key, value) {
      if (this.parent().name === 'CContainerItem' && key === 'width') {
        return this.parent().updateProp(key, `${value}%`)
      }
      let command = this.createCommand(key, value)
      return this.validateAndPushCommand(command)
    },
  },
})
</script>
